import React from "react";
import "./style.css";

import Skeleton from "../Skeleton/Skeleton";

const ProfileCardSkeleton = () => (
    <div className="profile-card">
        <Skeleton style={{ width: "100%", aspectRatio: "1 / 1" }} />
        <div className="wrapper">
            <Skeleton style={{ height: "1em", width: "70%", marginBottom: "0.5em" }} />
            <Skeleton style={{ height: "0.8em", width: "90%" }} />
        </div>
    </div>
);

export default ProfileCardSkeleton;
